/* eslint-disable eqeqeq */
import Table from '@oncolens/oncolens-ui/lib/components/Common/Table';
import { Tooltip } from '@oncolens/oncolens-ui/lib/components/FormControls/Tooltip';
import React, { useMemo } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import { QuestionWithGroups, getQipQuestionsWithGroups } from '../api/qip';
import { QipWithGroupsKeys } from '../api/qipwithgroups.keys';

interface Props {
  searchQuery: string;
}

const QipMetricQuestionsTable = ({ searchQuery }: Props) => {
  const columns = React.useMemo(
    () => [
      { accessor: 'id', Header: 'Id' },
      { accessor: 'version', Header: 'Version' },
      {
        accessor: 'name',
        Header: 'Name',
      },
      { accessor: 'type', Header: 'Type' },
      { accessor: 'status', Header: 'Status' },
      {
        accessor: 'associatedGroups',
        Header: 'Associated Groups',
        Cell: GroupColumn,
        disableSortBy: true,
      },
      { accessor: 'updatedDate', Header: 'Last Edited', Cell: LastEditedDateColumn },
    ],
    [],
  );

  const filters = {
    ...(searchQuery && { Filters: `(Name)@=*${searchQuery}` }),
  };

  const initialSort = useMemo(() => [{ id: 'updatedDate', desc: true }], []);

  const navigate = useNavigate();
  const navigateToEdit = (rowData: any) => navigate(`${rowData.id}`);

  return (
    <Table
      columns={columns}
      onRowClick={navigateToEdit}
      fetchData={getQipQuestionsWithGroups}
      queryBaseKey={QipWithGroupsKeys.baseKey}
      additionalQueryParameters={filters}
      options={{ textSize: 'sm' }}
      initialSort={initialSort}
    />
  );
};

interface QipMetricQuestionsTableRowProps {
  row: {
    original: QuestionWithGroups;
  };
}

const GroupColumn = ({ row: { original: rowData } }: QipMetricQuestionsTableRowProps) => {
  const groupNames = rowData.associatedGroups;

  const groupCount = (groupNames || 0) && groupNames.length;
  const sortedNames = groupNames.sort();

  return (
    <>
      {groupCount < 1 && <p>-</p>}
      {sortedNames && groupCount == 1 && <p>{sortedNames[0] ?? '-'}</p>}
      {groupCount > 1 && (
        <Tooltip
          text={sortedNames.map((name) => (
            <span className="block" key={name}>
              {name}
            </span>
          ))}
          icon={
            <p>
              <span className="flex items-center justify-center">
                {groupCount} Groups <FaInfoCircle className="ml-1.5 text-blue-400" />
              </span>
            </p>
          }
        />
      )}
    </>
  );
};

const LastEditedDateColumn = ({ row: { original: rowData } }: QipMetricQuestionsTableRowProps) => {
  const date = rowData.updatedDate.toLocaleString();
  return <span>{date}</span>;
};

export { QipMetricQuestionsTable as default };
